import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorPicker", "textField"]

  connect() {
    this.syncFromText()
  }

  colorChanged() {
    this.textFieldTarget.value = this.colorPickerTarget.value
  }

  textChanged() {
    const value = this.textFieldTarget.value
    if (this.isValidHexColor(value)) {
      this.colorPickerTarget.value = value
    }
  }

  syncFromText() {
    const value = this.textFieldTarget.value
    if (this.isValidHexColor(value)) {
      this.colorPickerTarget.value = value
    }
  }

  isValidHexColor(hex) {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)
  }
}